"use strict";
var $ = require("../internals/export");
var globalThis = require("../internals/global-this");
$({ global: true, forced: globalThis.globalThis !== globalThis }, {
  globalThis
});
